import React from 'react';
import Kpi from './Kpi';
import getDoc from "../../qdoc";

export default class QlikFilters extends React.Component {
  constructor(props) {
    super(props);
  }

  clearSelections() {
    getDoc.then(doc => {
      doc.clearAll(false, this.props.qStateName);
    });
  }

  render() {
    return (
      <div className="container">
        <div className="row flex-wrap justify-content-around align-items-center">
          <div className="p-2 mb-3 mt-3 kpi">
            <div className="">
              <img src="https://png.icons8.com/user-groups/office/80" title="contributor name" width="30" height="30"/>
            </div>
            <Kpi expression="=num(count({State1}distinct [Contributor Name]),'#,##0')"/>
            <div>Donors</div>            
          </div>
          <div className="p-2 mb-3 mt-3 kpi">
            <div className="">
              <img src="https://png.icons8.com/counter/office/80" title="dontaion counter" width="30" height="30"/>
            </div>
            <Kpi expression="=num(Sum({State1}DonationCount),'#,##0')"/>
            <div>Donations</div>            
          </div>
          <div className="p-2 mb-3 mt-3 kpi">
            <div className="">
              <img src="https://png.icons8.com/money/office/40" title="donation amount" width="30" height="30"/>
            </div>
            <Kpi expression="=num(Sum({State1}[Total Amount]),'$#,##0.00')"/>
            <div>Donation Amount</div>            
          </div>

        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/Kpis/index.js